export const defaultConfirmationPaneConfirmButtonStyles = {
  backgroundColor: "rgba(9,72,159,1)",
  color: "white",
  fontFamily: "Segoe UI, Arial, sans-serif",
  fontSize: "14px",
  fontWeight: "500",
  height: "32px",
  width: "80px"
};